export default {
  submit: "Submit",
  save: "Save",
  "submit.ok": "Submit successfully",
  "save.ok": "Saved successfully",
  "access-instructions": "Access Instructions",
  "enterprise-interface": "Enterprise Interface",
  appendix: "appendix",
};
